import React from 'react';
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import Button from '@mui/material/Button';

const useStyles = makeStyles({
    root: ({ widthBtn}) => ({
      width: widthBtn,
		  height: "36px",
    }),

});

export default function FlatBlueButton({title, typeButton, variant, widthBtn, onClick, isDisabled}) {
  const classes = useStyles({widthBtn});

  return (
    <Button 
      variant={variant}
      color={isDisabled ? "gray" : "primary"}
      type={typeButton}
      className={classes.root}
      onClick={onClick}
    >
      {title}
    </Button>
  );
}

FlatBlueButton.defaultProps = {
  onClick: () => null,
  typeButton: "button",
  variant: "contained",
  isDisabled: false,
};

FlatBlueButton.propTypes = {
  onClick: PropTypes.func,
  title: PropTypes.string.isRequired,
  typeButton: PropTypes.string,
  variant: PropTypes.string,
  widthBtn: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
};